import { Product } from "src/features/products/model/Product";
import { ProductModalSummary } from "src/features/products/model/ProductDetail";
import { thumbnail } from "./thumbnail";

export function getProductDetails(product: Product): ProductModalSummary {
  const percentage = Math.round(
    (+product?.price / +product?.retail_price) * 100
  );
  const percentageToString = percentage > 0 ? "%" + percentage : "";

  const details = {
    productPk: product.omniweb_id,
    productImage: thumbnail(
      product?.productimage_set?.[0]?.url,
      "product-live-comm"
    ),
    productDiscount:
      +product?.price < +product?.retail_price ? percentageToString : "",
    productName: product?.name,
    productPrice: product?.price,
    productRetailPrice: product?.retail_price,
    productUrl: product?.shop_url,
    combines: product?.combines,
  };

  return details;
}
